import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

import {
  GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_FAILURE,
  GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_REQUEST,
  GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_SUCCESS,
  GET_AUTH_UPDATE_IMPORT_TEMPLATES_FAILURE,
  GET_AUTH_UPDATE_IMPORT_TEMPLATES_REQUEST,
  GET_AUTH_UPDATE_IMPORT_TEMPLATES_SUCCESS,
  GET_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE,
  GET_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST,
  GET_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_FAILURE,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_REQUEST,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_SUCCESS,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_FAILURE,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_REQUEST,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_SUCCESS,
  POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS,
  PUT_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE,
  PUT_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST,
  PUT_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS,
} from './importAuthUpdates.types';

export const getAuthUpdateImportTemplates = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_AUTH_UPDATE_IMPORT_TEMPLATES_REQUEST, GET_AUTH_UPDATE_IMPORT_TEMPLATES_SUCCESS, GET_AUTH_UPDATE_IMPORT_TEMPLATES_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/Authorizations',
    method: 'GET',
  },
});

export const getAuthUpdateImportTemplate = templateId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST, GET_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS, GET_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/Authorizations/${templateId}`,
    method: 'GET',
  },
});

// Kept out of the clients reducer, which caches custom fields under the client currently open in client details
export const getAuthUpdateImportClientCustomFields = clientRecordId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_REQUEST, GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_SUCCESS, GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_FAILURE],
    authenticated: true,
    endpoint: `api/Client/customFields/${clientRecordId}`,
    method: 'GET',
  },
});

export const postAuthUpdateImportTemplate = template => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST, POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS, POST_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/Authorizations',
    method: 'POST',
    payload: template,
  },
});

export const putAuthUpdateImportTemplate = (templateId, template) => ({
  [CALL_INTAKE_V2_API]: {
    types: [PUT_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST, PUT_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS, PUT_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/Authorizations/${templateId}`,
    method: 'PUT',
    payload: template,
  },
});

export const uploadAuthUpdateImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_REQUEST, POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_SUCCESS, POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/Authorizations/${templateId}/DryRun`,
      method: 'POST',
      payload,
    },
  };
};

export const submitAuthUpdateImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_REQUEST, POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_SUCCESS, POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/Authorizations/${templateId}/Submit`,
      method: 'POST',
      payload,
    },
  };
};
